/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleExecutionParameterForNextGenReport extends models.ScheduleExecutionParameterBase {
    constructor() {
        super();
        this.setDiscriminator("ScheduleExecutionParameterForNextGenReport");
    }

    getFixupPrototypeFunction() { return ScheduleExecutionParameterForNextGenReport.fixupPrototype; }

    static newInstance(model: Partial<ScheduleExecutionParameterForNextGenReport>): ScheduleExecutionParameterForNextGenReport {
        let obj = Object.assign(new ScheduleExecutionParameterForNextGenReport(), model);
        ScheduleExecutionParameterForNextGenReport.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleExecutionParameterForNextGenReport>): ScheduleExecutionParameterForNextGenReport {
        if (!model) return null;
        return ScheduleExecutionParameterForNextGenReport.newInstance(<ScheduleExecutionParameterForNextGenReport> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleExecutionParameterForNextGenReport) {
        if (!obj) return;

        models.ScheduleExecutionParameterForNextGenReport.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleExecutionParameterForNextGenReport): boolean {
        if (models.ScheduleExecutionParameterBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ScheduleExecutionParameterForNextGenReport.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.configuration) {
            models.ConfigurationForNextGenReportBase.fixupPrototype(this.configuration);
        }
    }

    configuration: models.ConfigurationForNextGenReportBase;

    /**
     * NextGen Report type
     */
    report_type: models.NextGenReportType;

}
